import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { lookupOrder } from '../services/api';
import './OrderConfirmation.css';

const STATUS_LABELS = {
  awaiting_payment: 'Awaiting Payment',
  processing: 'Processing',
  shipped: 'Shipped',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
};

export default function OrderConfirmation() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    lookupOrder(orderNumber)
      .then(r => setOrder(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [orderNumber]);

  if (loading) return <div className="loading-center"><div className="spinner" /></div>;

  return (
    <div className="container" style={{ padding: '3rem 1.5rem', maxWidth: '700px' }}>
      <div className="confirmation-header">
        <div className="check-icon">✅</div>
        <h1>Order Confirmed!</h1>
        <p>Thank you for your purchase. You'll receive an email when your order ships.</p>
      </div>

      {order && (
        <div className="card">
          <div className="order-detail-row">
            <span>Order Number</span>
            <strong>{order.orderNumber}</strong>
          </div>
          <div className="order-detail-row">
            <span>Status</span>
            <span className={`badge badge-info`}>{STATUS_LABELS[order.status] || order.status}</span>
          </div>
          <div className="order-detail-row">
            <span>Total</span>
            <strong>${order.total?.toFixed(2)}</strong>
          </div>
          <div className="order-detail-row">
            <span>Subtotal</span>
            <span>${order.subtotal?.toFixed(2) || '0.00'}</span>
          </div>
          <div className="order-detail-row">
            <span>Shipping</span>
            <span>${order.shippingCost?.toFixed(2) || '0.00'}</span>
          </div>
          <div className="order-detail-row">
            <span>Tax</span>
            <span>${order.taxAmount?.toFixed(2) || '0.00'}</span>
          </div>
          {order.trackingNumber && (
            <div className="order-detail-row">
              <span>Tracking</span>
              <Link to={`/track?tracking=${order.trackingNumber}`} className="tracking-link">
                {order.trackingNumber} →
              </Link>
            </div>
          )}

          <div style={{ marginTop: '1.5rem' }}>
            <h3 style={{ marginBottom: '0.75rem', fontSize: '0.95rem' }}>Items Ordered</h3>
            {(order.items || []).map((item, i) => (
              <div key={i} className="order-item-row">
                <span>{item.title}</span>
                <span>× {item.qty}</span>
                <span>${(item.price * item.qty).toFixed(2)}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem', flexWrap: 'wrap' }}>
        <Link to="/track" className="btn btn-secondary">Track Your Order</Link>
        <Link to="/support" className="btn btn-secondary">Contact Support</Link>
        <Link to="/" className="btn btn-primary">Continue Shopping</Link>
      </div>
    </div>
  );
}
